const state = {
  isOpen: false,
  isMobile: false
}

export const getters = {
  menuIsOpen: state => state.isOpen,
  menuIsMobile: state => state.isMobile
}

export const actions = {
  changeStateMenu ({ commit }, value) {
    commit('SET_OPEN', value)
  },
  changeStateMobile ({ commit }, value) {
    commit('SET_MOBILE', value)
  }
}

export const mutations = {
  SET_OPEN (state, value) {
    state.isOpen = value
  },
  SET_MOBILE (state, value) {
    state.isMobile = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
